import React, { useEffect, useState } from "react";
import "../general.css";
import logo from "../assets/logo.png";
import Loading from "../Pages/Loading";
// import { useNavigate } from "react-router-dom";
import navigation from "../Auth/Navigation";

const StudentHomePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const navigation = useNavigate();

  const year = () => {
    let VarDate = new Date().getFullYear();
    return VarDate;
  };

  useEffect(() => {
    if (sessionStorage.getItem("Username") === null) {
      navigation("/");
    } else {
      sessionStorage.setItem("MainHome",sessionStorage.getItem("MainHome"));
    }
  }, []);

  const Student_Name = () => {
    return sessionStorage.getItem("Username");
  };

  const Logout = () => {
    setIsLoading(true);

    sessionStorage.clear();
    localStorage.clear();
    navigation("/");

    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const make_a_request = () => {
    setIsLoading(true);

    navigation("/Student-Home/MakeRequest");

    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const Get_Status = (StatusType) => {
    sessionStorage.setItem("StatusType", StatusType);
    sessionStorage.setItem("MainHome", "Student-Home");
    navigation("/StatusRequest");
  };

  return (
    <div className="main">
      {isLoading && <Loading />}
      <div className="Background">
        <div className="Header">
          <img src={logo} alt="University Logo" className="Logo" />
          <div className="title">
            VIT Document Approval System
          </div>
        </div>
        
        <div className="Main-Background">
          <div className="Content-Background">
            <div className="welcome-with-Logout-button">
              <div className="welcome-content">
                <div className="Welcome-Name">Welcome back, {Student_Name()}!</div>
                <div className="welcome-subtitle">Student Portal - Document Management Dashboard</div>
              </div>

              <button className="logout-button" onClick={Logout}>
                <span className="logout-icon">🚪</span>
                <span>Sign Out</span>
              </button>
            </div>

            <div className="dashboard-section">
              <h2 className="dashboard-title">Document Management</h2>
              <p className="dashboard-description">
                Submit new requests, track ongoing applications, and view your document history
              </p>
            </div>

            <div className="buttons-sets-home">
              <button onClick={make_a_request} className="dashboard-button primary-button">
                <span className="button-icon">📝</span>
                <span className="button-content">
                  <strong>Submit New Request</strong>
                  <small>Create and submit a new document request</small>
                </span>
                <span className="button-arrow">→</span>
              </button>

              <button
                className="dashboard-button status-button ongoing"
                onClick={() => Get_Status("Ongoing Requests")}
              >
                <span className="button-icon">⏳</span>
                <span className="button-content">
                  <strong>Ongoing Requests</strong>
                  <small>Track requests currently under review</small>
                </span>
                <span className="status-indicator">
                  <i className="Status Color-Green"></i>
                </span>
              </button>

              <button
                className="dashboard-button status-button approved"
                onClick={() => Get_Status("Approved Requests")}
              >
                <span className="button-icon">✅</span>
                <span className="button-content">
                  <strong>Approved Requests</strong>
                  <small>View successfully approved documents</small>
                </span>
                <span className="status-indicator">
                  <i className="Status Color-Blue"></i>
                </span>
              </button>

              <button
                className="dashboard-button status-button rejected"
                onClick={() => Get_Status("Rejected Requests")}
              >
                <span className="button-icon">❌</span>
                <span className="button-content">
                  <strong>Rejected Requests</strong>
                  <small>Review rejected applications and feedback</small>
                </span>
                <span className="status-indicator">
                  <i className="Status Color-Red"></i>
                </span>
              </button>
            </div>

            <div className="quick-stats">
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon">📊</div>
                  <div className="stat-content">
                    <div className="stat-number">12</div>
                    <div className="stat-label">Total Requests</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">⏳</div>
                  <div className="stat-content">
                    <div className="stat-number">3</div>
                    <div className="stat-label">Pending</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">✅</div>
                  <div className="stat-content">
                    <div className="stat-number">8</div>
                    <div className="stat-label">Approved</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">❌</div>
                  <div className="stat-content">
                    <div className="stat-number">1</div>
                    <div className="stat-label">Rejected</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-credit" style={{textAlign: 'center', marginTop: '2rem', color: '#64748b', fontWeight: 500}}>
              Developed by GARV ANAND
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentHomePage;
